// import { mdiDoorOpen } from '@mdi/js'
// import Icon from '@mdi/react'
// import React from 'react'

// const RoomIcon = (props) => {

//     const { size = 1 } = props

//     return (
//         <Icon
//             data-testid="IconButton__OpenRoom"
//             path={mdiDoorOpen}
//             size={size}
//             {...props}
//         />
//     )
// }

// export default React.memo(RoomIcon)

import { css } from '@emotion/react'
import Icon from '@mdi/react'
import { memo } from 'react'
import type { IconProps } from '.'

const roomIconStyles = css({
    overflow: 'hidden',
    position: 'relative',
    transform: 'translateY(10%)',
    '& svg:active': {
        display: 'none',
    },
})

const svg = `
M12.8374165,3.48 L12.8374165,15.408 L6.10022272,16.68 L6.10022272,1.944 L12.8374165,3.48 Z M21.4120267,16.8 L17.1247216,16.8 L17.1247216,0.6 C17.1247216,0.264 16.8552339,0 16.5122494,0 L5.48775056,0 C5.14476615,0 4.8752784,0.264 4.8752784,0.6 L4.8752784,16.8 L0.587973274,16.8 C-0.195991091,16.8 -0.195991091,18 0.587973274,18 L5.48775056,18 L5.61024499,18 L13.5723831,16.512 C13.8663697,16.464 14.0623608,16.2 14.0623608,15.912 L14.0623608,3 C14.0623608,2.712 13.8663697,2.472 13.596882,2.424 L8.23162584,1.2 L15.8997773,1.2 L15.8997773,17.4 C15.8997773,17.736 16.169265,18 16.5122494,18 L21.4120267,18 C22.1959911,18 22.1959911,16.8 21.4120267,16.8 L21.4120267,16.8 Z
M11,9.39130435 C11.4340286,9.39130435 11.7857143,9.7416 11.7857143,10.173913 C11.7857143,10.6062261 11.4340286,10.9565217 11,10.9565217 C10.5659714,10.9565217 10.2142857,10.6062261 10.2142857,10.173913 C10.2142857,9.7416 10.5659714,9.39130435 11,9.39130435
`
const filledSvg = `
M 12.8374 3.48 Z M 21.412 16.8 L 17.1247 16.8 L 17.1247 0.6 C 17.1247 0.264 16.8552 0 16.5122 0 L 5.4878 0 C 5.1448 0 4.8753 0.264 4.8753 0.6 L 4.8753 16.8 L 0.588 16.8 C -0.196 16.8 -0.196 18 0.588 18 L 5.4878 18 L 5.6102 18 L 13.5724 16.512 C 13.8664 16.464 14.0624 16.2 14.0624 15.912 L 14.0624 3 C 14.0624 2.712 13.8664 2.472 13.5969 2.424 L 8.2316 1.2 L 15.8998 1.2 L 15.8998 17.4 C 15.8998 17.736 16.1693 18 16.5122 18 L 21.412 18 C 22.196 18 22.196 16.8 21.412 16.8 L 21.412 16.8 Z M 11 9.3913 C 11.434 9.3913 11.7857 9.7416 11.7857 10.1739 C 11.7857 10.6062 11.434 10.9565 11 10.9565 C 10.566 10.9565 10.2143 10.6062 10.2143 10.1739 C 10.2143 9.7416 10.566 9.3913 11 9.3913
`

const RoomIcon = memo((props: IconProps) => {
    const { filled = false, size = 1, ...other } = props
    return (
        <Icon
            data-testid="IconButton__OpenRoom"
            path={filled ? filledSvg : svg}
            css={roomIconStyles}
            size={size}
            {...other}
        />
    )
})

export default RoomIcon
